import { render, staticRenderFns } from "./ContentSelection.vue?vue&type=template&id=38827556&scoped=true"
import script from "./ContentSelection.vue?vue&type=script&lang=js"
export * from "./ContentSelection.vue?vue&type=script&lang=js"
import style0 from "./ContentSelection.vue?vue&type=style&index=0&id=38827556&prod&lang=postcss&scoped=true"
import style1 from "./ContentSelection.vue?vue&type=style&index=1&id=38827556&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38827556",
  null
  
)

export default component.exports